@if (client$ | async; as client) {
  <zah-client-fiche
    [client]="client"
    (clientMeldingAdded)="onClientMeldingAdded(client, $event)"
    (backButtonClicked)="navigateBack()">
  </zah-client-fiche>
}
